import React from "react"
import {
  Container,
  Typography,
  Button,
  Grid,
  MuiThemeProvider,
} from "@material-ui/core"
import HeroShape from "shapes/HeroShape"
import Chips from "components/Chips"
import Footer from "components/Footer"
import SEO from "components/gatsby/SEO"
import { themeColor } from "services/constants"
import { AppStyles } from "assets/styles/App"
import ArticleBlockLink from "components/ArticleBlockLink"
import { graphql } from "gatsby"
import HeroBottom from "shapes/HeroBottom"

interface Props {
  data: any
}

const Blog: React.FC<Props> = ({ data }) => {
  const classes = AppStyles()

  return (
    <MuiThemeProvider theme={themeColor}>
      <SEO title="Blog" />
      <Chips />
      <Container maxWidth={false} className={classes.blogPageOuter}>
        <Container
          maxWidth="md"
          className={`${classes.heroInner} slide-in-fwd-center`}
        >
          <Container maxWidth={false}>
            <Typography
              className={classes.heroTitle}
              variant="h2"
              align="center"
              color="textPrimary"
              gutterBottom
            >
              My Blog
              <span role="img">📖</span>
            </Typography>
            <Typography
              className={classes.heroDesc}
              variant="h5"
              color="textPrimary"
              paragraph
            >
              Welcome to my blog. The topics that I cover are mostly about web
              technologies and development, focusing on front-end side. Things
              like <strong>Tips and Tricks</strong>,{" "}
              <strong>Best Practice</strong> and <strong>How to..</strong> are
              my main points to be share with. I usually wrote in{" "}
              <strong>Bahasa Melayu</strong> as I want to help{" "}
              <strong>Malaysians</strong> to understand more about web
              development process. If you have any concerns or questions, feel
              free to check my GitHub account and email me.
              <span role="img">😊</span>
            </Typography>
            <Container maxWidth={false} className={classes.heroButtons}>
              <Grid container spacing={2} justify="center">
                <Grid item>
                  <Button
                    href="mailto:wmaz93@gmail.com"
                    variant="contained"
                    color="primary"
                  >
                    Email me
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    variant="contained"
                    color="secondary"
                    href="https://github.com/warifmust"
                    target="_blank"
                  >
                    Github Account
                  </Button>
                </Grid>
              </Grid>
            </Container>
          </Container>
        </Container>
        {/* <HeroShape /> */}
        <HeroBottom />
      </Container>
      <Container maxWidth="md" className={classes.flexContainer}>
        {data.allNotionPageBlog.edges.map((edge: any, index: number) => (
          <ArticleBlockLink
            key={index}
            title={edge.node.title}
            link={`/blog/${edge.node.slug}`}
            excerpt={edge.node.excerpt}
            icon={edge.node.pageIcon}
            createdAt={edge.node.createdAt}
          />
        ))}
      </Container>
      <Footer />
    </MuiThemeProvider>
  )
}

export default Blog

export const query = graphql`
  query {
    allNotionPageBlog(
      filter: { isDraft: { eq: false } }
      sort: { fields: [indexPage], order: ASC }
    ) {
      edges {
        node {
          title
          slug
          excerpt
          pageIcon
          createdAt
        }
      }
    }
  }
`
